import React from 'react';

import styled from 'styled-components';

import Typography, { VARIANTS } from '@jobcase/react_pattern_library/components/Typography/TypographyRebrand';
import Link from '@jobcase/react_pattern_library/components/Link/LinkRebrand';
import styles from '@jobcase/react_pattern_library/styles/rebrand';

import { useDispatch } from 'react-redux';
import PromptEventModalRebrand from '../PromptEventModal/PromptEventModalRebrand';
import { updateAgreementAcceptStatus } from '../../redux/nodes/application/actions';
import { useSelector } from '../../utils/hooks';
import { getIsPolicyAccepted } from '../../redux/nodes/application/selectors';


const TNCPrompt = styled(PromptEventModalRebrand)`
  max-width: 382px !important;
  && {
    padding: ${styles.spacing.medium}px ${styles.spacing.small}px;
  }
  h1 {
    display: block;
    font-size: ${styles.font.fontSize.h1Mobile};
    line-height: ${styles.font.lineHeight.h1Mobile};
    margin: 0 0 ${styles.spacing.tiny}px;
    max-width: 100%;
  }
`;

const AgreementBody = styled(Typography)`
  margin: 0 0 ${styles.spacing.small}px;
  line-height: ${styles.font.lineHeight.body2};
  max-width: 330px;

  @media (min-width: ${styles.breakpoint.md}) {
    max-width: 100%;
  }
`;

const PolicyLink = styled(Link)`
  border: 0;
  cursor: pointer;
  font-weight: 400;
  line-height: ${styles.font.lineHeight.body2};
  padding: 0;
  text-decoration: underline;

  &:focus {
    border: 0;
  }
`;

const JobcaseAgreementModal = () => {
  const dispatch = useDispatch();
  const isJobcaseTermAccepted = useSelector(getIsPolicyAccepted);

  return (
    <>
      {!isJobcaseTermAccepted && (
        <TNCPrompt
          isVisible={!isJobcaseTermAccepted}
          isMobile
          headerText="We've updated the Jobcase Services Agreement!"
          primaryButtonText="Accept"
          hasCloseButton={false}
          primaryOnClick={() => {
            dispatch(updateAgreementAcceptStatus(true));
          }}
        >
          <AgreementBody variant={VARIANTS.BODY} color={styles.color.bodyTextColor}>
            Please review carefully. By clicking &ldquo;Accept&rdquo;, you confirm you have read and agree to the
            {' '}
            <PolicyLink href="https://jobcase.com/jobcase-services-agreement" target="_blank">
              Jobcase Services Agreement.
            </PolicyLink>
          </AgreementBody>
        </TNCPrompt>
      )}
    </>
  );
};

export default JobcaseAgreementModal;
